import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import TableHeader from '../../atoms/table/TableHeader';
import TableHeaderCell from '../../atoms/table/TableHeaderCell';
const StyledTableHeaderCell = styled(TableHeaderCell) `
    min-width: 30px;
    flex: 0;
`;
const ReportTableHeader = () => {
    return (_jsxs(TableHeader, { children: [_jsx(TableHeaderCell, { children: "Label" }), _jsx(TableHeaderCell, { children: "Datum" }), _jsx(TableHeaderCell, { children: "Filters" }), _jsx(TableHeaderCell, { children: "Status" }), _jsx(TableHeaderCell, { children: "Verloopt op" }), _jsx(StyledTableHeaderCell, {}), _jsx(StyledTableHeaderCell, {})] }));
};
export default ReportTableHeader;
